import React, { Component } from "react";
import { ReportCircleChart } from "./components";
import ReportBadge from "./ReportBadge";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";

const editorModules = {
  syntax: false,
  toolbar: [
    ["bold", "italic", "underline"],
    [{ size: ["small", false, "large", "huge"] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

export default class ReportCategoryHightlightsSuggestions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentContent: this.props.content ? this.props.content : "",
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return JSON.stringify(this.state) !== JSON.stringify(nextState);
  }

  _inputOnChange = (value) => {
    this.props.onChange({
      target: {
        name: this.props.name,
        value: value,
      },
    });

    this.setState({
      currentContent: value,
    });
  };

  _suggestionOnClick = (event) => {
    let current = this.state.currentContent;
    const adding = event.currentTarget.innerHTML;

    if (!current || current.indexOf("<ul>") === -1) {
      current = (current ? current : "") + `<ul><li>${adding}</li></ul>`;
    } else {
      current = current.replace("</ul>", `<li>${adding}</li></ul>`);
    }

    this.setState({
      currentContent: current,
    });
  };

  render() {
    const {
      content,
      editable,
      heading,
      previousScore,
      score,
      suggestions,
      title,
    } = this.props;

    const { currentContent } = this.state;

    return (
      <div className="report__page__wrapper">
        <div className="report__page report__page--bggreys">
          <div className="report_category__side">
            <div>
              <ReportCircleChart
                previousValue={previousScore}
                value={score}
                size={120}
                stroke={20}
              />
              <h2>{title}</h2>
            </div>
          </div>
          <div className="report_category__highlights">
            <h2>{heading}</h2>
            <ReactQuill
              readOnly={!editable}
              className="report__input report__input--full"
              theme="bubble"
              modules={editorModules}
              value={currentContent}
              defaultValue={content}
              onChange={this._inputOnChange}
            />
          </div>
        </div>
        <div className="report__options">
          {suggestions.map((item, key) => (
            <div key={key} className="report__options__checkitem">
              <p
                onClick={editable ? this._suggestionOnClick : null}
                dangerouslySetInnerHTML={{ __html: item }}
              />
            </div>
          ))}
        </div>
        <ReportBadge />
      </div>
    );
  }
}
